import { Address, LocalityAddress } from 'scenes/common/types';

export const toDisplayAddress = (
  address: Address | LocalityAddress | undefined
) => (address ? address.address.replace(/\n/g, ', ') : '');
